import React, { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import Logo from "../Components/Images/logo.png";
import { addDoc, collection } from "firebase/firestore";
import db from "../firestore";
import Header from "../Components/Header";

function AddBlog() {
  const [title, setTitle] = useState("");
  const [desc, setDesc] = useState("");
  const [text, setText] = useState("");
  const [date, setDate] = useState("");

  const blogRef = collection(db, "Blog");
  let navigate = useNavigate();

  const createBlog = async () => {
    await addDoc(blogRef, { Title: title, Text: text, Desc: desc, Date: date });
    navigate("/manageBlogs");
  };

  return (
    <div className="flex flex-col items-center">
      <Header />

      <div className="w-3/4 border rounded mt-10 p-5 flex flex-col gap-5">
        <h2 className="text-2xl font-bold">Adding Blog</h2>
        <input
          type="text"
          placeholder="Blog Title*"
          onChange={(e) => {
            setTitle(e.target.value);
          }}
          className="border rounded p-2"
        />
        <input
          type="text"
          placeholder="Blog Date (format = 30 Mar 2023)*"
          onChange={(e) => {
            setDate(e.target.value);
          }}
          className="border rounded p-2"
        />
        <input
          type="text"
          placeholder="Description*"
          onChange={(e) => {
            setDesc(e.target.value);
          }}
          className="border rounded p-2"
        />
        <textarea
          placeholder="Blog Content*"
          onChange={(e) => {
            setText(e.target.value);
          }}
          className="border rounded p-2"
        />

        <button
          className="rounded bg-add-green px-5 py-2 text-white hover:bg-add-green2 w-1/4"
          onClick={createBlog}
        >
          Add
        </button>
      </div>
    </div>
  );
}

export default AddBlog;
